import { SearchOutlined } from "@ant-design/icons";
import { Avatar, ConfigProvider, DatePicker, Input, Select, Timeline, Tooltip } from "antd";
import viVN from 'antd/locale/vi_VN';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/vi';
import React, { memo, useEffect, useState } from "react";
import { getCLStaff, IStaff } from "../../../../../../api/selectOption/selectOptionsApi";
import { avatarDefault, info_cicrle } from "../../../../../../components/ExportImgFigma";
import useToast from "../../../../../../hook/useToast";
import { fommatSelectOptionCreator, genderLinkForLogV3, handleDateChangeDayJs } from "../../../../../../until";
import '../../../style.scss';

import { getListHistoryLog, IListHistoryLog } from "../../../../../../api/Customer_V2/customerApi_V2";
import { IDetailGroup } from "../../../../../../api/groupCustomerV2/groupCustomerV2Api";
import { URL_AVATAR } from "../../../../../../env";
import useDebounce from "../../../../../../hook/useDebounce";
import useLoading from "../../../../../../hook/useLoading";

dayjs.locale('vi');

const { RangePicker } = DatePicker;
const data = [
    {
        date: "15/01/2024 14:20",
        user: "Admin Văn phòng điều hành",
        code: "NV1000",
        dept: "Phòng Kỹ thuật",
        email: "admin@thacoauto.com.vn",
        files: [
            { name: "IPCC_Ghi_chu_20240716_VinhLong.xls", type: "IPCC" },
        ],
        actions: [
            "Đã tạo thông tin chăm sóc dịch vụ",
            "Đã tạo thông tin người liên hệ",
            "Số điện thoại đã được bổ sung 0344735061",
        ],
    },
    {
        date: "15/01/2024 14:20",
        user: "Admin Văn phòng điều hành",
        code: "NV1000",
        dept: "Phòng Kỹ thuật",
        email: "admin@thacoauto.com.vn",
        files: [
            { name: "DDMS_Services_Bảng kê hợp đồng bán_VinhLong.xls", type: "DDMS - SERVICES" },
            { name: "DDMS_Services_Bảng kê lịch sử tiếp xúc_VinhLong.xls", type: "DDMS - SERVICES" },
        ],
        actions: [
            "Đã tạo thông tin xe sử dụng",
            "Đã tạo thông tin xe sở hữu",
            "Đã tạo thông tin xe quan tâm",
            "Đã tạo thông tin hỗ trợ/ khiếu nại",
            "Đã tạo thông tin khảo sát",
        ],
    },
    {
        date: "02/01/2024 08:00",
        user: "Admin Văn phòng điều hành",
        code: "NV1000",
        dept: "Phòng Kỹ thuật",
        email: "sertaima@thacoauto.com.vn",
        files: [
            { name: "DDMS_Sale_Customer_20230101_VinhLong.xls", type: "DDMS - SALE" },
        ],
        actions: ["Đã tạo thông tin hồ sơ khách hàng"],
    },
];

export interface IDataDefaulFilterList {
    search?: string;
    adminId?: number | undefined
    dateStart?: string
    dateEnd?: string
}

export const dataDefaulFilterList: IDataDefaulFilterList = {
    adminId: undefined,
    dateStart: '',
    dateEnd: '',
    search: ''
};


interface Props {
    inforGroup?: IDetailGroup
}

const VG_History: React.FC<Props> = ({ inforGroup }) => {
    useEffect(() => {

        gSLStaff()
    }, []);

    const pushToast = useToast()
    const pushLoading = useLoading()

    const [sLStaff, setSLStaff] = useState<IStaff[]>([])
    const [selectedValueTmp, setSelectedValueTmp] = useState<[Dayjs | null, Dayjs | null] | null>(null);
    const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)
    const [listDataHistoryLog, setListDataHistoryLog] = useState<IListHistoryLog[]>([]);

    const gSLStaff = async () => {
        const result = await getCLStaff()
        if (result?.status) {
            setSLStaff(result.data)
        } else {
            pushToast(result?.message, "warning")
        }
    }

    // const getListHistoryLog = async () => { }
    const gListHistoryLog = useDebounce(async () => {
        pushLoading(true)
        const {
            adminId, dateStart, dateEnd, search
        } = dataFilterList
        if (inforGroup?.id) {
            const result = await getListHistoryLog(
                inforGroup?.id, adminId, dateStart, dateEnd, search
            )
            if (result?.status) {

                setListDataHistoryLog(result.data)
            } else {
                pushToast(result?.message, "warning")
            }
        }
        pushLoading(false)
    }, 1000)

    useEffect(() => {
        if (selectedValueTmp) {
            // Có ngày được chọn
            setDataFilterList({
                ...dataFilterList,
                dateStart: handleDateChangeDayJs(selectedValueTmp[0]),
                dateEnd: handleDateChangeDayJs(selectedValueTmp[1])
            });
        } else {
            // Khi người dùng xóa ngày (clear)
            setDataFilterList({
                ...dataFilterList,
                dateStart: '',
                dateEnd: ''
            });
        }
    }, [selectedValueTmp]);


    useEffect(() => {
        gListHistoryLog()
    }, [dataFilterList, inforGroup])

    return (
        <div className="custom-page-css flex flex-col gap-5">
            <div className="custom-page-css w-full flex items-center gap-4">

                {/* <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm"
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        allowClear
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div> */}

                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm"
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className="border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>

                <ConfigProvider locale={viVN}>
                    <RangePicker
                        className="custom-input-date py-6px"
                        // open={true}
                        placeholder={["Bắt đầu", "Kết thúc"]}
                        format="DD/MM/YYYY"
                        allowClear
                        value={selectedValueTmp}
                        onReset={() => setSelectedValueTmp(null)}
                        onChange={(date) => setSelectedValueTmp(date)}
                        renderExtraFooter={() => (
                            <div className='w-full flex justify-end py-2'>
                                <button className='border-none bg-096DD9 text-sm rounded-2 h-8 px-4 font-regular text-white'
                                >Lưu</button>

                            </div>

                        )}
                    />
                </ConfigProvider>
                <div className='custom-page-css flex flex-1 align-center gap-2'>
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center  w-full">
                            <Select
                                showSearch
                                allowClear
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="Nhân viên"
                                options={fommatSelectOptionCreator(sLStaff)}
                                value={dataFilterList.adminId}
                                onChange={(e) => setDataFilterList({ ...dataFilterList, adminId: e })}
                            />

                        </div>
                        {/* <div className="  h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3 " />
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="custom-page-css ">
                <Timeline
                    className="custom-timeline overflow-hidden pt-3"
                    mode="left"
                    style={{ "--timeline-item-left-width": "80px" } as React.CSSProperties}
                    items={listDataHistoryLog.map((item, idx) => ({
                        key: idx,
                        dot: (
                            <Avatar
                                size={42}
                                src={
                                    <img
                                        src={URL_AVATAR + item.img}
                                        onError={(e) => {
                                            e.currentTarget.src = avatarDefault;
                                        }}
                                    />
                                }
                            />
                        ),
                        label: (
                            <div style={{ width: 80, textAlign: "right" }} className="custom-page-css text-475467 text-base font-regular">
                                <div>{item.createdAt.split(" ")[0]}</div>
                                <div>{item.createdAt.split(" ")[1]}</div>
                            </div>
                        ),
                        children: (
                            <>
                                <div className="custom-page-css font-medium text-sm">
                                    {item.fullname} (<span className="" style={{ color: "#1890FF" }}>{item.code}</span>)
                                    {/* | {item.dept} */}
                                </div>
                                <div className="custom-page-css text-xs text-667085 font-regular pb-1">{item.email}</div>
                                {/* actions */}
                                <ul className="custom-page-css bg-F8F8F8 mt-2 list-disc-none text-sm px-2 py-2 rounded ">
                                    {item.HistorySummaries.map((item, i) => (
                                        <li key={i} className="custom-page-css flex items-center gap-1">
                                            <div>{genderLinkForLogV3(item)}</div>
                                            <Tooltip
                                                className={`${item.historyLogDetails.length ? "" : "d-none"}`}
                                                placement="right"
                                                color="white"
                                                title={
                                                    <div className="Tooltip-custom-css">
                                                        {item.historyLogDetails.map((itemC, j) => (
                                                            <div key={j} className="custom-page-css flex items-center gap-7 justify-between ">
                                                                <span className="custom-page-css text-sm font-regular text-667085">
                                                                    {"customer" in itemC
                                                                        ? itemC.customer?.username
                                                                        : itemC.admin?.fullname}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            >
                                                <div className="custom-page-css flex items-center gap-1 bg-E6F7FF rounded-lg px-2 cursor-pointer">
                                                    <div className="font-light color-bage">{item.historyLogDetails.length}</div>
                                                    <img src={info_cicrle} alt="Avatar" />
                                                </div>
                                            </Tooltip>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        ),
                    }))}
                />
            </div>
        </div>
    )
}

export default memo(VG_History);